/** @format */

import useThrottledCallback from '@common/application/hooks/useThrottledCallback/useThrottledCallback';

export default useThrottledCallback;
